import React from 'react';

import { Link } from 'react-router-dom';
import { Layout } from 'components/organisms/layout';
import { ContentsTitle, } from 'components/molecules';
/** styles **/
import s from '../styles/pages/p-man-comic.module.scss';
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';
import { Comics } from 'components/organisms/comics';

export const PmanComic: React.FC = () => {
  return (
    <Layout>
      <div className={s.comicPageWrapper}>
        <ContentsTitle className={s.contentsTitle} title="P-man4コマ劇場" subTitle="4コマ漫画でわかるP-manライフ" />
        <div className={s.worriesList}>
          <Comics />
        </div>

        <Link className={s.topLink} to="/">
          <BlackCircleArrow className={s.navButton} />トップページへ戻る
        </Link>
      </div>
    </Layout>
  );
};
